$('.chart-duration').find('a').each(function () { $(this).bind('keydown', HandleKeyDown); });

function HandleKeyDown(evt) {
    if ((evt.keyCode === 32 && evt.which === 32 )|| (evt.keyCode === 13 && evt.which === 13)) {
        evt.preventDefault();

        var durationId = $(this).attr('data-id');

        var chartModule = $(this).closest('.chartModule');

        if (chartModule) {
            var chartModuleId = chartModule[0].id;

            SetChartDuration(chartModuleId, durationId);
        }
    }

    return;
}

function SetChartDuration(chartModuleId, durationId) {
    var $chartModuleId = $("#" + chartModuleId);

    if ($chartModuleId[0] != undefined) {
        // Update selected control
        SetActiveChartDuration(chartModuleId, durationId);

        // get chart dimensions
        var duration = $('#' + chartModuleId + ' .' + durationId).attr('duration-value');
        var height = $('#' + chartModuleId + ' .chart-container').height();
        var width = $('#' + chartModuleId + ' .chart-container').width();

        var action = $('#' + chartModuleId + ' .chart-duration').attr('refresh-action');

        var search = window.location.search; // gets symbol from the query string

        // Build URL
        var url = action + search + '&duration=' + duration + '&height=' + height + '&width=' + width;

        // Call controller to get updated chart
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
        }).done(function (data, status, jqXHR) {
            if (data) {
                // Place returned partial div on page
                $('#' + chartModuleId + ' .chart-container').html(data);
            }
        }).fail(function (jqXHR, exception) {
            showError(jqXHR);
        });
    }
}

function SetActiveChartDuration(chartModuleId, durationId) {
    // This is set up to work with multiple duration controls for cases when the
    // control appears above the chart at one breakpoint and below at another. 
    // Just add two instances of the control and show/hide the active/inactive 
    // instance 

    // Set active on li
    $('#' + chartModuleId + ' .chart-duration li').removeClass('active');
    $('#' + chartModuleId + ' .' + durationId).parent().addClass('active');

    // Set aria-selected on li a
    $('#' + chartModuleId + ' .chart-duration li a').attr('aria-selected', false);
    $('#' + chartModuleId + ' .' + durationId).attr('aria-selected', true);

    // Set active on li a
    $('#' + chartModuleId + ' .chart-duration li a').removeClass('active');
    $('#' + chartModuleId + ' .' + durationId).addClass('active');
}